import { render, staticRenderFns } from "./ModalMethod.vue?vue&type=template&id=497f0e01&scoped=true&"
import script from "./ModalMethod.vue?vue&type=script&lang=ts&"
export * from "./ModalMethod.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMethod.vue?vue&type=style&index=0&id=497f0e01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f0e01",
  null
  
)

export default component.exports